module.exports = __webpack_public_path__ + "img/9.b4e6a15a.jpg";